module.exports = __webpack_public_path__ + "email_notifications-8a867ec39b3ab464d8231a86b35ea794.svg";